// constants/propertyType.ts
export const listingTypeOption = [
  { value: "1", name: "رهن و اجاره" },
  { value: "2", name: "خرید و فروش" },
];
